export {
  PAYMENT_V2_BASE_URL,
  PAYMENT_V2_ENDPOINT_V1,
  PAYMENT_V2_ENDPOINT_V2,
} from "@/data/urls";

export enum PLAN_INTENT {
  BUY = "buy",
  TRIAL = "trial",
}
